// Service Worker registration for PWA
// Only registers in production (not in development) to avoid dev-time cache issues.
export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  // Register after the page has loaded to avoid competing with critical resources
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // Check for updates every hour
        setInterval(() => registration.update(), 60 * 60 * 1000);
      })
      .catch((err) => {
        // Silent fail — SW is a progressive enhancement
        console.warn('Service worker registration failed:', err);
      });
  });
}
